import * as AccountInformationI from "./AccountInformation";
import * as PermissionManagementI from "./PermissionManagement";

export const SequencePattern: Record<string, Record<string, Record<string, any>>> = {
  AccountInformation: {
    default: {
      START: AccountInformationI.Start,
      Action: AccountInformationI.Action,
    },
  },
  PermissionManagement: {
    default: {
      START: PermissionManagementI.Start,
      Action: PermissionManagementI.Action,
    },
  },
};

export default SequencePattern;
